import { showErrorMessage } from '@eltoro-ui/components'
import { V1ListPixelsResponse } from 'next-gen-sdk'
import { getApiUrl, toCamelCase } from '../Helpers'
import axios from 'axios'

export const listPixels = async (
  pageSize?: number,
  pageToken?: string,
  orgId?: string,
  orderBy?: string,
  id?: string,
  name?: string,
  tags?: Array<string>,
): Promise<V1ListPixelsResponse | undefined> => {
  const token = localStorage.getItem('eltoro_token')

  if (!token) return

  try {
    const url = `${getApiUrl()}/v1/pixels`

    // Build query parameters
    const params = new URLSearchParams()

    if (pageSize !== undefined) params.append('page_size', pageSize.toString())
    if (pageToken) params.append('page_token', pageToken)
    if (orgId) params.append('org_id', orgId)
    if (orderBy) params.append('order_by', orderBy)
    if (id) params.append('id', id)
    if (name) params.append('name', name)

    // Handle tags as multiple parameters
    if (tags && tags.length > 0) {
      tags.forEach((tag) => {
        if (tag.trim()) {
          params.append('tags', tag.trim())
        }
      })
    }

    const response = await axios.get(`${url}?${params.toString()}`, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    })

    return toCamelCase(response.data) as V1ListPixelsResponse
  } catch (error) {
    showErrorMessage('Error listing pixels', (error as any)?.message || '')
    throw error
  }
}
